<template>
  <v-col
      cols="12"
      class="details-wrapper">
    <div class="order-collective-resident-detail">
      <div class="name">{{ resident.name }}</div>
      <div class="lastOrder"></div>
      <div class="unit">{{ detail.unit }}</div>
      <div class="quantity">
        <QuantityInput v-model="count" min="0"
                       :small="true"
                       :disabled="isUpdating ||( !isEditable || (detail.geloescht == '1' && !isModelC))"
                       :changed="changed"
                       ref="quantityInput"></QuantityInput>
      </div>
      <div class="quantitySuggestion"></div>
    </div>
  </v-col>
</template>

<script>
import {mapGetters} from 'vuex'
import ArticleImage from '../../Article/ArticleImage.vue'
import ArticleCaption from '../../Article/ArticleCaption.vue'
import ArticleDetailDialog from "@/components/SmartLogistics/Article/ArticleDetailDialog.vue";
import {cleanLineBreaks} from '@/utils/String'
import ArticleMessageIndicator from "@/components/SmartLogistics/Article/ArticleMessageIndicator.vue";
import QuantityInput from "@/components/shared/QuantityInput.vue";
import resident from "../../Resident/Resident.vue";

export default {
  name: 'OrderSuggestionArticleDetail',
  components: {QuantityInput, ArticleMessageIndicator, ArticleDetailDialog, ArticleCaption, ArticleImage},
  props: {
    resident: {
      type: Object,
      required: true
    },
    detail: {
      type: Object,
      required: true
    },
  },
  computed: {

    ...mapGetters({
      isEditable: 'smartLogisticOrderSuggestion/isOrderSuggestionEditable',
      planModel: 'smartLogisticSettings/planModel',
      isModelB: "smartLogisticSettings/isModelB",
      isModelC: "smartLogisticSettings/isModelC",
      isUpdating: "smartLogisticOrderSuggestion/isUpdating"
    }),

    changed() {
      return this.detail.plannedSingleUnitsEdited !== this.detail.plannedSingleUnits
    },

    count: {
      get() {
        return this.detail.plannedSingleUnitsEdited
      },
      set(value) {
        if (value < 0) {
          value = 0
        }
        this.$store.dispatch('smartLogisticOrderSuggestion/updateArticle', {
          artikelNrLAG: this.detail.internalID,
          ownerType: 'resident',
          ownerId: this.resident.internalID,
          plannedSingleUnitsEdited: parseInt(value),
          orderSuggestionEdited: null,
        })
      }
    },
  },
  methods: {
    increase() {
      this.$refs.quantityInput.increase();
    },
    decrease() {
      this.$refs.quantityInput.decrease();
    },
  },
}
</script>
<style lang="scss">
.order-suggestion-article.deleted {
  * {
    color: #9E9E9E;
  }
}
</style>
